import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';
import { ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeSpaceToken, } from '../theme-tokens';
const baseStyle = defineStyle({
    fontSize: ThemeFontSizeToken.Medium,
    fontFamily: ThemeFontToken.SubHeader,
    color: ThemeColorToken.OnBackground,
    fontWeight: 'normal',
    marginBottom: ThemeSpaceToken.XSmall,
    _disabled: {
        opacity: 1,
        color: ThemeColorToken.OnBackground,
    },
});
export const formLabelConfig = defineStyleConfig({
    baseStyle,
});
//# sourceMappingURL=form-label-theme.js.map